import React from 'react';

import SvgIcon from '@mui/material/SvgIcon';

const JobBadgeIcon = () => (
  <SvgIcon>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="24" height="24" rx="4" fill="#F7F3FE" />
      <path
        d="M13.5 7.875V6.375H10.5V7.875H13.5ZM6 9.375V17.625H18V9.375H6ZM18 7.875C18.8325 7.875 19.5 8.5425 19.5 9.375V17.625C19.5 18.4575 18.8325 19.125 18 19.125H6C5.1675 19.125 4.5 18.4575 4.5 17.625L4.5075 9.375C4.5075 8.5425 5.1675 7.875 6 7.875H9V6.375C9 5.5425 9.6675 4.875 10.5 4.875H13.5C14.3325 4.875 15 5.5425 15 6.375V7.875H18Z"
        fill="#7A23FF"
      />
    </svg>
  </SvgIcon>
);

export default JobBadgeIcon;
